// extracted by mini-css-extract-plugin
export default {"card":"ZodiacCard_card__Zf3H8","icon":"ZodiacCard_icon__0M7uL","signName":"ZodiacCard_signName__GtW3T","dateRange":"ZodiacCard_dateRange__tBjYM"};